<template>
  <div class="main-container">
    <div class="games-page">
      <div class="games-page__left">
        <main-menu></main-menu>
      </div>
      <div class="games-page__right">
        <h2 class="main-title">Versions</h2>
        <Loader v-if="gamesLoadInProgress || versionLoadInProgress"></Loader>

        <div v-else class="games">

          <div class="games-search">
            <FilterInput title="Search by name" :filterList="games" :filterByKey="filterFields" v-on:filter="onFilter">
            </FilterInput>
          </div>

          <table class="table">
            <thead>
              <tr>
                <th class="games__column-name">Name</th>
                <th class="games__column-feeds">Feeds</th>
                <th class="games__column-tags">Tags</th>
                <th class="games__column-desc">Description</th>
                <th class="games__column-ver">Version</th>
                <th class="games__column-prod">Last Production Date</th>
                <th class="games__column-action">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="game in filteredGames" :key="game.selectedGameVersion.key" class="games__item">
                <td colspan="7" v-if="isGameRequestInProgress(game)" class="games__loader">
                  <Loader></Loader>
                </td>
                <td v-if="!isGameRequestInProgress(game)" class="games__name">
                  {{ game.name }} <br /> ({{ game.slug }})
                </td>
                <td v-if="!isGameRequestInProgress(game)" class="games__feeds">
                  <div v-if="game.isShortViewFeeds" class="shortViewFeeds">
                    <v-card-text>
                      {{ getFeedsForGame(game).slice(0, 4).join(", ") }}
                      <p v-if="getFeedsForGame(game).length > 4">
                        ...<v-btn x-small text color="primary" @click="showFullViewFeeds(game)">more</v-btn>
                      </p>
                    </v-card-text>
                  </div>
                  <div v-else class="fullViewFeeds">
                    <div class="table-item" :key="ind" v-for="(feed, ind) in getFeedsForGame(game)">{{ feed }}</div>
                    <v-btn x-small text color="primary" @click="showShortViewFeeds(game)">less</v-btn>
                  </div>
                  <v-btn @click.stop="showGameFeedsPopup(game)">Details({{ getFeedsForGame(game).length }})</v-btn>
                </td>
                <td v-if="!isGameRequestInProgress(game)" class="games__tags">
                  <p :key="tagName" v-for="(tagName) in  getTagsParsed(game.selectedGameVersion.tags)">
                    {{ tagName }}
                  </p>
                </td>
                <td v-if="!isGameRequestInProgress(game)" class="games__desc">
                  {{ game.selectedGameVersion.description }}
                </td>
                <td v-if="!isGameRequestInProgress(game)" class="games__ver">
                  <select class="form__select" style="margin-bottom: 2px" v-model="game.selectedVersion"
                    @change="selectedGameVersionChange($event, game)">
                    <option selected :key="version.key" :value="version.version" v-for="(version) in game.versions">
                      {{ versionLabel(version) }}
                    </option>
                  </select>
                  <v-btn v-if="game.selectedGameVersion.status === 2 && $checkRoles(['Administrator'])"
                    @click="updateStatus(game, game.selectedGameVersion, 1)" class="blue">
                    <span>Enable</span>
                  </v-btn>
                  <v-btn v-if="game.selectedGameVersion.status === 1 && $checkRoles(['Administrator'])"
                    @click="updateStatus(game, game.selectedGameVersion, 2)" class="red">
                    <span>Disable</span>
                  </v-btn>
                </td>
                <td v-if="!isGameRequestInProgress(game)" class="games__production">
                  {{ toDateString(game.selectedGameVersion.lastProductionDate) }}
                </td>
                <td v-if="!isGameRequestInProgress(game)" class="games__action">
                  <v-btn v-if="$checkRoles(['Administrator'])" :disabled="isGamePresentInAnyFeed(game)"
                    @click="showDeleteGamePopup(game)" class="red">
                    <span>Delete</span>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <DeleteModal v-if="isDeleteModalVisible" :itemToDel="gameToDelete.name" v-on:submit="deleteGame"
      v-on:close="closeDeleteGamePopup"></DeleteModal>
    <FeedsPopup v-if="isShowFeedVersionsModalVisible" :isVisible="dialogPopup" :game="gameToFeedsPopup"
      :feeds="feedsToFeedsPopup" :list-versions="listVersionToFeedsPopup" @close="closeGameFeedsPopup">
    </FeedsPopup>
  </div>
</template>

<script>
import Loader from "../../Loader/Loader.vue";
import config from "../../../config";
import FilterInput from "../../FilterInput/FilterInput.vue";
import DeleteModal from "../../DeleteModal/DeleteModal.vue";
import MainMenu from "../../MainMenu/MainMenu.vue";
import FeedsPopup from "./FeedsPopup.vue";

export default {
  components: { MainMenu, Loader, FilterInput, DeleteModal, FeedsPopup },
  name: "GamesVersionsMainPage",
  data() {
    return {
      games: [],
      feeds: null,
      gameToDelete: null,
      isDeleteModalVisible: false,
      versionLoadInProgress: false,
      gamesLoadInProgress: false,
      gameDeleteInProgress: false,
      gameStatusUpdateInProgress: false,
      gameToFeedsPopup: "",
      dialogPopup: false,
      listVersionToFeedsPopup: [],
      feedsToFeedsPopup: [],
      isShowFeedVersionsModalVisible: false,
      gameRequestInProgressSlug: "",
      filteredGames: [],
      filterFields: ["slug", "name"]
    };
  },
  created: function () {
    this.getGames();
  },
  methods: {
    toDateString: function (date) {
      if (date == null) {
        return date;
      }
      return new Date(date).toDateString();
    },
    versionLabel: function (game) {
      if (game.status === 1) {
        return `${game.version} (Active)`;
      }
      return game.version;
    },
    isGameRequestInProgress: function (game) {
      if (game.slug === this.gameRequestInProgressSlug) {
        return true;
      }
    },
    isGamePresentInAnyFeed: function (game) {
      if (this.feeds[game.slug]) {
        return true;
      }
    },
    getFeedsForGame: function (game) {
      let result = this.feeds[game.slug];
      if (result) {
        return result;
      }
      return [];
    },
    getTagsParsed: function (tags) {
      return typeof tags === 'string' ? JSON.parse(tags) : tags;
    },
    onFilter: function (games) {
      this.filteredGames = games;
    },
    getGames: function () {
      this.gamesLoadInProgress = true;
      this.versionLoadInProgress = true
      this.$gameApi.get(`/games`).then((games) => {
        this.games = this.games || [];
        games.forEach(game => {
          this.games.push({
            ...game,
            name: game.name + ' (Game API)',
            slug: game.slug + '-game-api',
            versions: [ { version: game.version, active: game.active } ],
          })
        });
      });
    },
    showGameFeedsPopup: function (game) {
      this.dialogPopup = true;
      this.gameToFeedsPopup = game.slug;
      this.feedsToFeedsPopup = this.getFeedsForGame(game);
      this.isShowFeedVersionsModalVisible = true;
    },
    closeGameFeedsPopup: function () {
      this.dialogPopup = false
      this.gameToFeedsPopup = null;
      this.feedsToFeedsPopup = [];
      this.isShowFeedVersionsModalVisible = false;
    },
    showShortViewFeeds: function (game) {
      game.isShortViewFeeds = true
    },
    showFullViewFeeds: function (game) {
      game.isShortViewFeeds = false
    },
    showDeleteGamePopup: function (game) {
      this.gameToDelete = game;
      this.isDeleteModalVisible = true;
    },
    closeDeleteGamePopup: function () {
      this.gameToDelete = null;
      this.isDeleteModalVisible = false;
    },
    deleteGame: function () {
      let slug = this.gameToDelete.slug;
      this.closeDeleteGamePopup();
      this.gameDeleteInProgress = true;
      this.gameRequestInProgressSlug = slug;
      this.$http.delete(`${config.apiUrl}/game/delete/${slug}`)
        .then(response => {
          this.gameDeleteInProgress = false;
          this.gameRequestInProgressSlug = "";
          // sync javascript object with back-end without reload data
          this.games = this.games.filter(element => {
            return element.slug !== slug;
          });
          this.filteredGames = this.games; // attaching all games to filteredGames to show them.
        }, error => {
          console.log(error);
          this.gameDeleteInProgress = false;
          this.gameRequestInProgressSlug = "";
        });
    },
    selectedGameVersionChange: function (e, game) {
      game.versions.forEach(v => {
        if (v.version === game.selectedVersion) {
          game.selectedGameVersion = v;
        }
      });
    },
    updateStatus(allVersions, game, status) {
      this.gameStatusUpdateInProgress = true;
      this.gameRequestInProgressSlug = game.slug;

      this.$http.post(`${config.apiUrl}/game/status/change`, {
        "Key": game.key,
        "Slug": game.slug,
        "Status": status
      })
        .then(response => {
          this.gameStatusUpdateInProgress = false;
          this.gameRequestInProgressSlug = "";

          // sync javascript object with back-end without reload data
          if (status === 1) {
            allVersions.versions.forEach(v => {
              if (v.key !== game.key) {
                v.status = 2;
              } else {
                v.status = 1;
              }
            });
          } else {
            game.status = 2;
          }
        }, error => {
          console.log(error);
          this.gameStatusUpdateInProgress = false;
          this.gameRequestInProgressSlug = "";
        });
    }
  }
};
</script>

<style scoped src="./gamesVersionsMainPage.scss" lang="scss"></style>
